// 商品与搜索：英文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 移动商品
export const mobileProduct = Object.freeze({
  "mobile.product.back": "Back",
  "mobile.product.home": "Home",
  "mobile.product.share": "Share",
  "mobile.product.inspected": "Inspected",
  "mobile.product.viewInspectionImages": "View inspection photos",
  "mobile.product.remaining": "{count} left",
  "mobile.product.minimumOrder": "min. order",
  "mobile.product.approximately": "≈ ",
  "mobile.product.sourceLocation": "Stock location",
  "mobile.product.batch": "Batch",
  "mobile.product.days": " days",
  "mobile.product.deliveryDays": "Delivery time",
  "mobile.product.sectionNavigation": "Product detail sections",
  "mobile.product.parameters": "Parameters",
  "mobile.product.specification": "Datasheet",
  "mobile.product.contactInfo": "Contact details",
  "mobile.product.substitutes": "Alternatives",
  "mobile.product.parameterInfo": "Specifications",
  "mobile.product.basicParameters": "Basic details",
  "mobile.product.brand": "Brand",
  "mobile.product.partNumber": "Part number",
  "mobile.product.copyPartNumber": "Copy part number",
  "mobile.product.batchDc": "Batch (DC)",
  "mobile.product.manufacturer": "Manufacturer",
  "mobile.product.validityPeriod": "Validity period",
  "mobile.product.originProof": "Certificate of origin",
  "mobile.product.yes": "Yes",
  "mobile.product.no": "No",
  "mobile.product.condition": "Condition",
  "mobile.product.physicalSpecs": "Physical specifications",
  "mobile.product.weight": "Weight",
  "mobile.product.dimensions": "Dimensions",
  "mobile.product.length": "Length",
  "mobile.product.width": "Width",
  "mobile.product.height": "Height",
  "mobile.product.categoryAttributes": "Category attributes",
  "mobile.product.productCategory": "Product category",
  "mobile.product.aiAnswer": "Ask XSOU AI",
  "mobile.product.specificationPdf": "Datasheet PDF",
  "mobile.product.loading": "Loading",
  "mobile.product.preview": "Tap to preview",
  "mobile.product.downloadSpecification": "Download datasheet",
  "mobile.product.download": "Download",
  "mobile.product.noSpecification": "No datasheet available",
  "mobile.product.viewNegotiatorProfile": "View negotiator profile",
  "mobile.product.negotiator": "Negotiator",
  "mobile.product.chatOnline": "Chat online",
  "mobile.product.phoneNumber": "Phone",
  "mobile.product.copyPhone": "Copy phone number",
  "mobile.product.callPhone": "Call phone number",
  "mobile.product.call": "Call",
  "mobile.product.wechatId": "WeChat ID",
  "mobile.product.copyWechatId": "Copy WeChat ID",
  "mobile.product.noSubstitutes": "No alternatives available",
  "mobile.product.favorited": "Saved",
  "mobile.product.favorite": "Save",
  "mobile.product.contact": "Contact",
  "mobile.product.addToCart": "Add to cart",
  "mobile.product.quickOrder": "Quick order",
  "mobile.product.contactService": "Ask customer service",
  "mobile.product.submitPurchaseIntent": "Submit purchase inquiry",
  "mobile.product.expectedPrice": "Target price",
  "mobile.product.price": "Price",
  "mobile.product.quantity": "Quantity",
  "mobile.product.buyerName": "Buyer name",
  "mobile.product.enterBuyerName": "Enter buyer name",
  "mobile.product.buyerPhone": "Buyer phone",
  "mobile.product.enterBuyerPhone": "Enter buyer phone number",
  "mobile.product.deliveryAddress": "Delivery address",
  "mobile.product.enterDeliveryAddress": "Enter delivery address",
  "mobile.product.required": "Required",
  "mobile.product.referredNegotiator": "Referring negotiator",
  "mobile.product.enterNegotiatorPhone": "Enter negotiator phone number",
  "mobile.product.chooseQuantity": "Select quantity",
  "mobile.product.addedToCart": "Added to cart",
  "mobile.product.continueShopping": "Continue shopping",
  "mobile.product.goToCart": "View cart",
  "mobile.product.shareTo": "Share to",
  "mobile.product.cancel": "Cancel",
  "mobile.product.wechat": "WeChat",
  "mobile.product.douyin": "Douyin",
  "mobile.product.xiaohongshu": "Xiaohongshu",
  "mobile.product.weibo": "Weibo",
  "mobile.product.requiredField": "Required field",
  "mobile.product.enterValidNumber": "Enter a valid number",
  "mobile.product.agentService": "Customer service",
  "mobile.product.online": "Online",
  "productSpecification.loginRequired": "Sign in to view or download this datasheet.",
  "productSpecification.notNow": "Not now",
  "productSpecification.accessDenied": "You do not have permission to view this datasheet.",
  "productSpecification.notFound": "This datasheet does not exist or has been deleted.",
  "mobile.product.notice": "Notice",
  "mobile.product.loginRequired": "Please log in to continue",
  "mobile.product.goToLogin": "Log in",
  "mobile.product.keepBrowsing": "Keep browsing",
  "mobile.product.verifyIdentityFirst": "Log in and verify your identity first",
  "mobile.product.copySucceeded": "Copied",
  "mobile.product.copyFailed": "Could not copy",
  "mobile.product.verifyIdentity": "Verify your identity first",
  "mobile.product.insufficientStock": "Insufficient stock to add to cart",
  "mobile.product.enterQuantity": "Enter a quantity",
  "mobile.product.belowMinimumQuantity":
    "Cart quantity must exceed the minimum order ({quantity})",
  "mobile.product.notBoundBuyer":
    "Only the buyer linked to this product can add it to the cart",
  "mobile.product.confirmBoundPhone": "Confirm linked phone number",
  "mobile.product.boundPhoneQuestion":
    "This product is linked to {phone}. Is this your number?",
  "mobile.product.confirm": "Confirm",
  "mobile.product.purchaseIntentSubmitted":
    "Purchase inquiry submitted. Please wait for a sales response.",
  "mobile.product.specificationUrlFailed":
    "Could not open the datasheet. Please try again later",
  "mobile.product.sharedTo": "Shared to: {name}",
});

// 移动搜索
export const mobileSearch = Object.freeze({
  "mobile.search.backHome": "Back to home",
  "mobile.search.ai": "XSOU AI",
  "mobile.search.all": "All",
  "mobile.search.products": "Products",
  "mobile.search.wiki": "Wiki",
  "mobile.search.wikiResults": "Wiki results",
  "mobile.search.productResults": "Product results",
  "mobile.search.allResults": "All results",
  "mobile.search.resultCount": "{count} results",
  "mobile.search.searching": "Searching",
  "mobile.search.noResults": "No matching results",
  "mobile.search.publisher": "Published by: {name}",
  "mobile.search.userPublished": "Published by a user",
  "mobile.search.priceOnRequest": "Price on request",
  "mobile.search.stockUnconfirmed": "Stock to be confirmed",
  "mobile.search.viewDetails": "View details",
  "mobile.search.recentSearches": "Recent searches",
  "mobile.search.clearHistory": "Clear search history",
  "mobile.search.wikiSearchFailed":
    "Wiki search failed. Please try again later",
  "mobile.search.searchFailed": "Search failed. Please try again later",
  "mobile.search.productList": "Product list",
  "mobile.search.searchProducts": "Search products",
  "mobile.search.sales": "Sales",
  "mobile.search.price": "Price",
});

// 桌面商品
export const desktopProduct = Object.freeze({
  "pcProduct.seller": "Seller",
  "pcProduct.back": "Back",
  "pcProduct.mainImage": "Main product image",
  "pcProduct.thumbnail": "Thumbnail",
  "pcProduct.inspected": "Inspected",
  "pcProduct.share": "Share",
  "pcProduct.wechat": "WeChat",
  "pcProduct.weibo": "Weibo",
  "pcProduct.douyin": "Douyin",
  "pcProduct.xiaohongshu": "Xiaohongshu",
  "pcProduct.details": "Product details",
  "pcProduct.validity": "Validity",
  "pcProduct.manufacturer": "Manufacturer",
  "pcProduct.deliveryDays": "Delivery time",
  "pcProduct.daysValue": "{count} days",
  "pcProduct.weight": "Weight",
  "pcProduct.originProof": "Certificate of origin",
  "pcProduct.yes": "Yes",
  "pcProduct.no": "No",
  "pcProduct.dimensions": "Dimensions",
  "pcProduct.applications": "Applications",
  "pcProduct.category": "Product category",
  "pcProduct.categoryAttributes": "Category attributes",
  "pcProduct.contactDetails": "Contact details",
  "pcProduct.contactPerson": "Contact",
  "pcProduct.negotiatorSuffix": " (Negotiator)",
  "pcProduct.phone": "Phone",
  "pcProduct.wechatId": "WeChat ID",
  "pcProduct.consultNegotiator": "Chat with the negotiator",
  "pcProduct.specification": "Datasheet",
  "pcProduct.specLoading": "Loading datasheet",
  "pcProduct.downloadSpec": "Download datasheet",
  "pcProduct.fullScreen": "View full screen",
  "pcProduct.substitutes": "Alternative products",
  "pcProduct.brand": "Brand",
  "pcProduct.partNumber": "Part number",
  "pcProduct.price": "Price",
  "pcProduct.approximately": "Approx. ",
  "pcProduct.minimumOrderSuffix": " minimum",
  "pcProduct.stock": "Stock",
  "pcProduct.goodsCondition": "Condition",
  "pcProduct.specPartNumber": "Specification / part number",
  "pcProduct.batch": "Batch",
  "pcProduct.sourceLocation": "Source location",
  "pcProduct.minimumOrder": "Minimum order",
  "pcProduct.quantity": "Quantity",
  "pcProduct.favorite": "Favorite",
  "pcProduct.contact": "Contact",
  "pcProduct.addToCart": "Add to cart",
  "pcProduct.quickOrder": "Quick order",
  "pcProduct.agentService": "Customer support",
  "pcProduct.addedToCart": "Added to cart",
  "pcProduct.addedToCartDetail": "This product is now in your cart",
  "pcProduct.productImage": "Product image",
  "pcProduct.continueShopping": "Continue shopping",
  "pcProduct.checkoutCart": "View cart and checkout",
  "pcProduct.required": "Required",
  "pcProduct.validNumber": "Enter a valid number",
  "pcProduct.aiAnswers": "Ask XSOU AI",
  "pcProduct.loginAndVerifyFirst":
    "Log in and complete identity verification first",
  "pcProduct.copySuccess": "Copied",
  "pcProduct.copyFailed": "Copy failed",
  "pcProduct.confirmBoundPhone":
    "This product is linked to {phone}. Is this your number?",
  "pcProduct.boundPhoneTitle": "Confirm linked phone number",
  "pcProduct.confirm": "Confirm",
  "pcProduct.cancel": "Cancel",
  "pcProduct.verifyFirst": "Complete identity verification first",
  "pcProduct.notBoundBuyer":
    "Only the linked buyer can add this product to the cart",
  "pcProduct.insufficientStock": "Insufficient stock to add to cart",
  "pcProduct.belowMinimum":
    "Cart quantity must be at least the minimum order quantity ({quantity})",
});

// 桌面搜索
export const desktopSearch = Object.freeze({
  "pcSearch.placeholder":
    "Search part numbers, names, brands, wiki and listings",
  "pcSearch.clear": "Clear",
  "pcSearch.search": "Search",
  "pcSearch.ai": "XSOU AI",
  "pcSearch.all": "All",
  "pcSearch.product": "Products",
  "pcSearch.wiki": "Wiki",
  "pcSearch.supplyDemand": "Supply & Demand",
  "pcSearch.bidding": "Bidding",
  "pcSearch.index": "Market Index",
  "pcSearch.user": "User",
  "pcSearch.resultSummary": "{count} {type} results for “{keyword}”",
  "pcSearch.enterKeyword": "Enter a keyword to search across XSOU",
  "pcSearch.priceOnRequest": "Price on request",
  "pcSearch.stockPending": "Stock to be confirmed",
  "pcSearch.stockCount": "Stock: {count}{unit}",
  "pcSearch.viewDetails": "View details",
  "pcSearch.pagination": "Search result pages",
  "pcSearch.previousPage": "Previous page",
  "pcSearch.nextPage": "Next page",
  "pcSearch.searching": "Searching...",
  "pcSearch.noResults": "No matching results",
  "pcSearch.tryAnotherKeyword":
    "Try a part number, brand, wiki entry or product name.",
  "pcSearch.enterSearchText": "Enter a search term",
  "pcSearch.productQueryFailed":
    "Product search is temporarily unavailable. Try again later.",
  "pcSearch.wikiQueryFailed":
    "Wiki search is temporarily unavailable. Try again later.",
  "pcSearch.wikiEntry": "Wiki entry",
  "pcSearch.communityWiki": "Community wiki",
  "pcSearch.datasheetAvailable": "Datasheet available",
  "pcSearch.communityPublished": "Community contribution",
  "pcSearch.publishedBy": "Published by: {name}",
  "pcSearch.skHynix": "SK hynix",
  "pcSearch.datasheet": "Datasheet",
});

// 规格书
export const specification = Object.freeze({
  "pcSpecification.title": "Datasheet management",
  "pcSpecification.subtitle": "View wiki datasheets downloaded by this account",
  "pcSpecification.refresh": "Refresh",
  "pcSpecification.empty": "No downloaded datasheets",
  "pcSpecification.partNumber": "Datasheet part number",
  "pcSpecification.points": "Points spent",
  "pcSpecification.downloadedAt": "Downloaded at",
  "pcSpecification.expiresAt": "Expires at",
  "pcSpecification.status": "Status",
  "pcSpecification.valid": "Valid",
  "pcSpecification.expired": "Expired",
  "pcSpecification.actions": "Actions",
  "pcSpecification.viewWiki": "View wiki entry",
  "pcSpecification.loadFailed":
    "Could not load downloaded datasheets. Try again later",
  "pcSpecification.missingWiki":
    "No matching wiki entry was found for this datasheet",
});

// 手机端业务流程：固定界面文案。
export const mobileWorkflow = Object.freeze({
  "goodsLibrary.selectVideo": "Select a video file",
  "goodsLibrary.confirmCreate": "Confirm creation",
  "goodsLibrary.enterCode": "Enter a product code",
  "goodsLibrary.imageUrlHint": "Enter an image URL or upload an image",
  "goodsLibrary.particleInformation": "Chip information",
  "goodsLibrary.wafer": "Wafer",
  "goodsLibrary.yield": "Yield",
  "goodsLibrary.stack": "Stack",
  "goodsLibrary.priceStock": "Price and inventory",
  "goodsLibrary.mediaDescription": "Media and description",
  "goodsLibrary.wideImage": "Wide display image",
  "goodsLibrary.wideImageHint": "Enter a wide image URL or upload an image",
  "goodsLibrary.gallery": "Gallery images",
  "goodsLibrary.galleryHint":
    "Enter or upload gallery images, separated by commas",
  "goodsLibrary.videoUrl": "Video URL",
  "goodsLibrary.videoHint": "Enter a video URL or upload a video",
  "goodsLibrary.sellingPoints": "Selling points",
  "goodsLibrary.sellingPointsHint": "Enter the product selling points",
  "goodsLibrary.removeFile": "Remove file",
  "goodsLibrary.chooseFromLibrary": "Choose from library",
  "goodsLibrary.allowedBuyersHint":
    "Add buyers allowed to purchase this product by mobile number",
  "goodsLibrary.closeSaleRange": "Close the sale range dialog",
  "goodsLibrary.newBuyerPhone": "Add a buyer mobile number",
  "goodsLibrary.addPhonesHint":
    "Enter a mobile number and select Add. You can add multiple buyers.",
  "goodsLibrary.allowedBuyers": "These buyers may purchase this product",
  "goodsLibrary.noBuyerPhones": "No buyer mobile numbers added",
  "goodsLibrary.addPhoneFirst": "Add at least one mobile number",
  "goodsLibrary.videoLimit": "Videos supported, up to {size} MB",
  "goodsLibrary.imageLimit": "Images supported, up to {size} MB",
  "goodsLibrary.enterFileUrl": "Enter a file URL or upload a file",
  "goodsLibrary.fileSizeLimit": "File size must not exceed {size} MB",
  "goodsLibrary.pageSizeOption": "{size} per page",
  "goodsLibrary.bindProduct": "Link product",
  "goodsLibrary.offSale": "Unlisted",
  "goodsLibrary.onSale": "Listed",
  "goodsLibrary.soldOut": "Sold out",
  "goodsLibrary.platformUnlisted": "Unlisted by platform",
  "goodsLibrary.storeUnavailable": "Store unavailable",
  "goodsLibrary.supplierUnlisted": "Unlisted by supplier",
  "goodsLibrary.supplierDisabled": "Supplier disabled",
  "goodsLibrary.missingId": "Product ID is unavailable",
  "goodsLibrary.enterName": "Enter a product name",
  "goodsLibrary.created": "Created successfully",
  "goodsLibrary.listed": "Listed",
  "goodsLibrary.chooseExcelFormat": "Choose an xls or xlsx file",
  "goodsLibrary.chooseExcelFirst": "Choose an Excel file first",
  "goodsLibrary.enterPageRange": "Enter a page number from 1 to {total}",
  "goodsLibrary.overview": "Product overview",
  "goodsLibrary.title": "Product library",
  "goodsLibrary.refresh": "Refresh products",
  "goodsLibrary.currentResults": "Current results",
  "goodsLibrary.activeOnPage": "Listed on this page",
  "goodsLibrary.inactiveOnPage": "Unlisted on this page",
  "goodsLibrary.searchName": "Search by product name",
  "goodsLibrary.searchCode": "Search by product code",
  "goodsLibrary.filterStatus": "Filter by product status",
  "goodsLibrary.salePrice": "Sale price",
  "goodsLibrary.loading": "Loading products",
  "goodsLibrary.loadFailed": "Unable to load products",
  "goodsLibrary.noResults": "No matching products",
  "goodsLibrary.create": "Add product",
  "goodsLibrary.pagination": "Product list pagination",
  "goodsLibrary.page": "Page",
  "goodsLibrary.jumpToPage": "Go to page",
  "goodsLibrary.actions": "Product actions",
  "goodsLibrary.edit": "Edit product",
  "goodsLibrary.listProduct": "List product",
  "goodsLibrary.pageSize": "Products per page",
  "goodsLibrary.pageNumber": "Page number",
  "goodsLibrary.excelImport": "Excel import",
  "goodsLibrary.importTitle": "Import product data",
  "goodsLibrary.chooseExcel": "Choose an Excel file",
  "goodsLibrary.excelFormats": "Supports xls and xlsx files",
  "goodsLibrary.importCompleted": "Import complete",
  "goodsLibrary.imported": "Imported successfully",
  "goodsLibrary.productCountUnit": "products",
  "goodsLibrary.duplicatePartNumbers": "Duplicate part numbers",
  "goodsLibrary.startImport": "Start import",
});

// PC界面显示文案；不改动业务原值。
export const productFixedFacts = Object.freeze({
  "pcProduct.whiteLabel": "Unbranded",
  "pcProduct.factorySealedBox": "Original sealed box",
  "pcProduct.originalFactoryPackaging": "Original factory packaging",
  "pcProduct.nonFactoryPackaging": "Non-factory packaging",
  "pcProduct.conditionSeparator": ", ",
  "pcProduct.quantityWithUnit": "{count} {unit}",
  "pcProduct.unitPiece": "pcs",
  "pcProduct.unitItem": "pcs",
  "pcProduct.unitBox": "boxes",
  "pcProduct.unitSet": "sets",
});

// 页面受控选项与属性显示；原始业务值保持不变。
export const attributeDisplayFollowup = Object.freeze({
  "pcProduct.unitMilligram": "mg",
  "pcProduct.unitKilogram": "kg",
  "pcProduct.unitKilogramColloquial": "kg",
  "pcProduct.attributePackage": "Package",
  "pcProduct.attributeColor": "Color",
  "pcProduct.colorBlue": "Blue",
  "pcProduct.colorRed": "Red",
  "pcProduct.colorBlack": "Black",
  "pcProduct.colorWhite": "White",
  "pcProduct.factoryOpenedBox": "Original box, opened",
});

export const goodsFeedback = Object.freeze({
  "goodsFeedback.confirmList": "List “{name}” for sale?",
  "goodsFeedback.confirmDeleteGoods": "Permanently delete “{name}”?",
});


// 搜索结果展示：PC 与移动端共用。
export const searchResultsPresentation = Object.freeze({
  "searchResults.aiTitle": "XSOU AI",
  "searchResults.basicInfo": "Basic information",
  "searchResults.executionComplete": "Completed",
  "searchResults.candidateHint": "The input may be incomplete or contain ambiguous characters. Check these returned candidates.",
  "searchResults.partialIntro": "Some information is available for this part number. ",
  "searchResults.remainingUnknown": "Other parameters remain unconfirmed",
  "searchResults.compareHeading": "Parameter",
  "searchResults.noAlternatives": "No supported replacement candidates are available. Direct compatibility has not been confirmed.",
  "searchResults.questionAnswer": "{model}: {parameter} is {value}.",
  "searchResults.sources": "Sources",
  "searchResults.difference": "Different",
  "searchResults.parameterName": "Name",
  "searchResults.parameterDescription": "Description",
  "searchResults.parameterLabel": "Part-number parameters",
  "searchResults.noImage": "No image",
  "searchResults.aiTemporaryResult": "Temporary AI result",
  "searchResults.standardAnswerSource": "Standard answer · AI explanation unconfirmed",
  "searchResults.wikiPartialUnavailable": "Some encyclopedia sources are unavailable. Available results are shown.",
  "searchResults.noPrice": "Price unavailable",
  "searchResults.noStock": "Stock unavailable",
  "searchResults.aiEmptyTitle": "No reliable information found",
  "searchResults.aiEmptyDescription": "No usable information for “{keyword}” is available. Accurate parameters cannot be provided.",
  "searchResults.aiLoginTitle": "Sign in to view AI insights",
  "searchResults.aiLoginDescription": "Sign in to request AI insights for this keyword.",
  "searchResults.aiLogin": "Sign in",
  "searchResults.checkLabel": "Check the following",
  "searchResults.checkModel": "Full part number",
  "searchResults.checkModelDescription": "Check for missing characters, spaces or ambiguous characters.",
  "searchResults.checkBrand": "Manufacturer",
  "searchResults.checkBrandDescription": "Include the manufacturer to narrow the search.",
  "searchResults.checkSuffix": "Model suffix",
  "searchResults.checkSuffixDescription": "Check the chip marking or complete ordering code.",

  "searchResults.platformProducts": "Platform products",
  "searchResults.similarProducts": "Similar products",
  "searchResults.popularSearches": "Popular searches",
  "searchResults.weeklyProducts": "Popular parts this week",
  "searchResults.matchedCount": "Matching products · {count}",
  "searchResults.viewAll": "View all products ({count})",
  "searchResults.moreProducts": "More products",
  "searchResults.similarHint": "Same brand or similar part numbers. Verify specifications and compatibility before substitution.",
  "searchResults.similarLoading": "Loading similar products…",
  "searchResults.noSimilar": "No other similar products found",
  "searchResults.fallbackPopular": "No popular searches available",
  "searchResults.popularLoading": "Loading popular searches…",
  "searchResults.noPopular": "No popular searches available",
  "searchResults.popularityUnavailable": "Popularity data is temporarily unavailable",
  "searchResults.goodsLoading": "Loading products…",
  "searchResults.noRecommended": "No recommended products",
  "searchResults.expandAi": "Expand AI answer",
  "searchResults.collapseAi": "Collapse AI answer",
  "searchResults.tryAlso": "Also try",
  "searchResults.noDetail": "Details unavailable",
  "searchResults.purchase": "View offer",
  "searchResults.viewProduct": "View product",
  "searchResults.wikiUnavailable": "Encyclopedia service unavailable. Please try again later.",
});

export const searchDataPresentation = Object.freeze({
  "searchData.currentModel": "Current model",
  "searchData.compatibility": "Compatibility",
  "searchData.selectionAdvice": "Selection guidance",
  "searchData.selectModel": "Search this model",
  "searchData.coverageStart": "Data collection started at {time} (Beijing time)",

  "searchData.model": "Part number",
  "searchData.brand": "Brand",
  "searchData.ambiguous": "The full model is unclear. Please confirm the part number.",
  "searchData.conflict": "Sources differ",
  "searchData.unknown": "Unconfirmed",
  "searchData.parameter": "Parameter",
  "searchData.comparison": "Model comparison table; scroll horizontally",
  "searchData.alternatives": "Candidate model comparison",
  "searchData.verified": "Verified direct replacement",
  "searchData.candidate": "Candidate; verify conditions and compatibility",
  "searchData.similarUnavailable": "Similar products are temporarily unavailable. Please try again later.",
  "searchData.hotProducts": "Popular parts this week",
  "searchData.field.brand": "Brand",
  "searchData.field.productType": "Product type",
  "searchData.field.capacity": "Chip capacity",
  "searchData.field.bitWidth": "Bit width",
  "searchData.field.speed": "Frequency / Data rate",
  "searchData.field.frequency": "Frequency",
  "searchData.field.package": "Package / Balls",
  "searchData.field.ball": "Ball count",
  "searchData.field.voltage": "Voltage",
  "searchData.field.pins": "Pin count",
  "searchData.field.ddr": "DDR generation",
  "searchData.field.density": "Density",
  "searchData.field.organization": "Organization",
  "searchData.field.yield": "Yield",
  "searchData.field.pinout": "Pinout",
  "searchData.field.timing": "Timing",
  "searchData.field.ballPitch": "Ball pitch",
  "searchData.field.controller": "Controller compatibility",
  "searchData.field.pcbValidation": "PCB validation",
  "searchData.source.mall": "Platform product",
  "searchData.source.erp": "ERP record",
  "searchData.source.partNumber": "Part-number registry",
  "searchData.source.knowledge": "Knowledge base",
  "searchData.source.rule": "Rule parsing",
  "searchData.source.reviewed": "Reviewed data",
  "searchData.source.specification": "Datasheet",
  "searchData.review.recorded": "Recorded",
  "searchData.review.parsed": "Parsed",
  "searchData.review.approved": "Approved",
});

export const messages = Object.freeze({
  ...searchDataPresentation,
  ...searchResultsPresentation,
  ...goodsFeedback,
  ...attributeDisplayFollowup,
  ...productFixedFacts,
  ...mobileWorkflow,
  "goodsRecognition.examples":
    "Example 1: M321RAJA0MB0-CWM usd 4350.0*500 pcs,  25+ NON CN , 1-2days\nExample 2: In stock. Month-end volume offers; contact us for firm orders. KLM4G1FETE-B041  25+  12800",
  ...mobileProduct,
  ...mobileSearch,
  ...desktopProduct,
  ...desktopSearch,
  ...specification,
});
